"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var currency_js_1 = __importDefault(require("currency.js"));
var React = __importStar(require("react"));
var react_1 = require("react");
var react_dom_1 = require("react-dom");
var react_hook_form_1 = require("react-hook-form");
var selected_variant_state_1 = require("../../misc/selected-variant-state");
var modal_1 = __importDefault(require("../../plugins/modal"));
var app_1 = __importDefault(require("../pdp-add-to-cart/app"));
function VariantSelector(_a) {
    var product = _a.product, modalSettings = _a.modalSettings, nonShoppableSiteSettings = _a.nonShoppableSiteSettings, pdpAddToCartSettings = _a.pdpAddToCartSettings;
    var variants = product.variants;
    var optionNames = product.options;
    var isDiaperProduct = optionNames.includes('Design');
    var enableModal = modalSettings.enableModal;
    var selVariant = (0, selected_variant_state_1.useSelectedVariantStore)(function (state) { return state.variant; });
    // single variant products won't need to have option pickers
    var isSingleVariant = (selVariant === null || selVariant === void 0 ? void 0 : selVariant.option1) === 'Default Title';
    var _b = __read((0, react_1.useState)(), 2), availableSecondaryOptions = _b[0], setActiveSecondOptions = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), isModalOpen = _c[0], setIsModalOpen = _c[1];
    var _d = (0, react_hook_form_1.useForm)({
        mode: 'all',
        defaultValues: {
            option1: selVariant === null || selVariant === void 0 ? void 0 : selVariant.option1,
            option2: selVariant === null || selVariant === void 0 ? void 0 : selVariant.option2,
        },
    }), register = _d.register, control = _d.control, setValue = _d.setValue;
    // mapping of 'base' options to their 'secondary' options.
    // e.g. {baseOption: "Size N", secondaryOptions: ["Sleepy Sloths", "Alphabet"]}
    var options = (0, react_1.useMemo)(function () {
        return variants.reduce(function (acc, curr) {
            var existingBaseOption = acc.some(function (optionMap) { return optionMap.baseOption === curr.option1; });
            // if we don't already have the current base option, then we can add it
            if (!existingBaseOption) {
                acc.push({ baseOption: curr.option1, secondaryOptions: [curr.option2] });
            }
            else {
                // if we already have the current base option, add the second option to its secondaryOptions array for the base option
                var exists = acc.find(function (optionMap) { return optionMap.baseOption === curr.option1; });
                exists === null || exists === void 0 ? void 0 : exists.secondaryOptions.push(curr.option2);
            }
            return acc;
        }, []);
    }, [variants]);
    // only relevant for diaper products
    var diaperOptions = (0, react_1.useMemo)(function () {
        // product is not a diaper pattern in this case
        if (!isDiaperProduct) {
            return undefined;
        }
        return product.variants.reduce(function (acc, variant) {
            var _a;
            var existingPattern = acc.find(function (pattern) { return pattern.patternTitle === variant.option2; });
            if (!existingPattern) {
                acc.push({ patternTitle: variant.option2, imgSrc: (_a = variant.featured_image) === null || _a === void 0 ? void 0 : _a.src });
            }
            return acc;
        }, []);
    }, [product, isDiaperProduct]);
    var activeBaseOption = (0, react_hook_form_1.useWatch)({ control: control, name: 'option1' });
    var activeSecondOption = (0, react_hook_form_1.useWatch)({ control: control, name: 'option2' });
    var changeSelectedVariant = (0, selected_variant_state_1.useSelectedVariantStore)(function (state) { return state.change; });
    // for updating the selected variant
    // TODO: Come up with a better way of doing this that doesn't require an effect. Something more event-based.
    (0, react_1.useEffect)(function () {
        var _a;
        var secondaryOptions = (_a = options.find(function (option) { return option.baseOption === activeBaseOption; })) === null || _a === void 0 ? void 0 : _a.secondaryOptions;
        if (secondaryOptions) {
            setActiveSecondOptions(secondaryOptions);
        }
        if (!secondaryOptions)
            return;
        // if we can maintain the user's option2, doing so is a better user experience
        var variantWithExistingOption2 = variants.find(function (variant) { return variant.option1 === activeBaseOption && variant.option2 === activeSecondOption; });
        // if there are no variants available with the user's new option1 and their existing option2, arbitrarily choose an available option2 for them
        var newVariantToSelect = variantWithExistingOption2 || variants.find(function (variant) { return variant.option1 === activeBaseOption && variant.option2 === secondaryOptions[0]; });
        if (newVariantToSelect) {
            var newSelectedVariant_1 = __assign(__assign({}, newVariantToSelect), { product: { tags: product.tags, title: product.title } });
            (0, react_dom_1.unstable_batchedUpdates)(function () {
                var priceDollars = (0, currency_js_1.default)(newSelectedVariant_1.price, { fromCents: true }).value;
                changeSelectedVariant({ newVariant: __assign(__assign({}, newSelectedVariant_1), { price: priceDollars }), emitViewItemEventToGa: true });
            });
        }
    }, [activeBaseOption, activeSecondOption, options, product.tags, variants, changeSelectedVariant, product.title]);
    var handleModalOpen = function () {
        setIsModalOpen(true);
    };
    var handleModalClose = function () {
        setIsModalOpen(false);
    };
    return (React.createElement(React.Fragment, null,
        enableModal && (React.createElement(modal_1.default, { isOpen: isModalOpen, handleClose: handleModalClose },
            React.createElement("div", { className: 'padding-vertical-10 grid-container' },
                React.createElement("div", { className: 'padding-vertical-3' }, modalSettings.modalText),
                React.createElement("div", { className: 'show-for-medium' },
                    React.createElement("img", { src: modalSettings.modalImage, alt: 'Desktop modal image' })),
                React.createElement("div", { className: 'hide-for-medium' },
                    React.createElement("img", { src: modalSettings.mobileModalImage, alt: 'Mobile modal image' }))))),
        !isSingleVariant && (React.createElement("div", null, optionNames.map(function (option, i) {
            // the base option is option1
            var isBaseOption = i === 0;
            return (React.createElement("div", { key: i },
                React.createElement("div", { className: 'padding-vertical-2', style: { fontSize: '14px' } },
                    React.createElement("span", { className: 'font-bold' },
                        option,
                        ": "),
                    isBaseOption && enableModal && (React.createElement("a", { className: 'position-relative float-right text-wisteria text-underline', onClick: handleModalOpen }, modalSettings.linkText)),
                    option === 'Design' && React.createElement("span", null, activeSecondOption)),
                option !== 'Design' && (React.createElement("label", null,
                    React.createElement("select", { name: isBaseOption ? 'option1' : 'option2', ref: register() }, isBaseOption
                        ? options.map(function (opt) { return (React.createElement("option", { key: opt.baseOption, value: opt.baseOption }, opt.baseOption)); })
                        : availableSecondaryOptions === null || availableSecondaryOptions === void 0 ? void 0 : availableSecondaryOptions.map(function (opt) { return (React.createElement("option", { key: opt, value: opt }, opt)); })))),
                option === 'Design' ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { hidden: true, ref: function () { return register('option2'); } }), diaperOptions === null || diaperOptions === void 0 ? void 0 :
                    diaperOptions.map(function (pattern) {
                        var isSelected = activeSecondOption === pattern.patternTitle;
                        return (React.createElement("div", { className: 'display-inline-block padding-right-2', style: { height: '65px', width: '65px' }, key: pattern.patternTitle },
                            React.createElement("a", { className: (0, classnames_1.default)('bordered border-transparent circle display-block overflow-hidden', isSelected && 'border-black'), href: 'javascript:void(0)', style: { borderWidth: '1px' } },
                                React.createElement("img", { src: pattern.imgSrc, alt: pattern.patternTitle, onClick: function () { return setValue('option2', pattern.patternTitle); } }))));
                    }))) : (React.createElement(React.Fragment, null))));
        }))),
        React.createElement("div", { className: 'show-for-medium padding-vertical-5' },
            React.createElement(app_1.default, __assign({ nonShoppableSiteSettings: nonShoppableSiteSettings }, pdpAddToCartSettings)))));
}
// the problem is just above here
exports.default = VariantSelector;
